<template>
  <v-list-item v-if="!item.loading" class="pl-3 pr-2" activeClass="rivery" :to="to">
    <v-list-item-icon class="ma-0 my-auto mr-3" style="height: unset;">
      <ArticleImage :articleNumber="item.ArticleNumber" :size="40" :timeType="item.Type">
      </ArticleImage>
    </v-list-item-icon>
    <v-list-item-content class="py-0">
      <v-list-item-title> {{ item.ArticleNumber }} </v-list-item-title>
      <v-list-item-subtitle> {{ item.ArticleDescription }} </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="ml-2">
      <v-chip label small>{{ formatCount() }}x</v-chip>
    </v-list-item-action>
    <v-list-item-action class="ml-2">
      <v-chip label outlined small style="min-width: 70px" class="justify-end" :color="colorizePart(item)">
        {{ item.TotalAmountExclVat - item.TotalDiscount }},-
      </v-chip>
    </v-list-item-action>
  </v-list-item>
  <v-skeleton-loader v-else type="list-item" style="height: 48px;"></v-skeleton-loader>
</template>


<script>
import ArticleImage from "@/views/pim/articles/ArticleImage.vue";

export default {
  name: 'OrderDetailListItem',
  props: {
    item: Object,
    to: Object,
  },
  components: {
    ArticleImage,
  },

  data() {
    return {};
  },

  methods: {
    formatCount() {
      return parseFloat(this.item.ArticleCount.toFixed(2));
    },

    colorizePart(item) {
      if (item.Discount > 0) {
        return "item-discounted"
      }
      return "";
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>